export const FETCH_ACTiVE_DEVICES = "FETCH_ACTiVE_DEVICES" ;
